import React, { useState } from 'react';
import moment from 'moment';
import {
  DateParam,
  NumberParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { Grid, Stack, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { DatePicker } from '@mui/x-date-pickers';

import { AppBar, Empty, Error, Loader } from '@/components';
import { PaymentsToExpertsTable } from './components';
import {useLazyGetPaymentsToExpertsReportQuery} from "@/services/reports";

const PaymentsToExpertsReportPage: React.FC = () => {
  const [{ date_from, date_to, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    date_from: withDefault(DateParam, moment().startOf('month').toDate()),
    date_to: withDefault(DateParam, moment().toDate()),
  });

  const [trigger, {
    data: paymentsToExperts,
    isLoading,
    isFetching,
    isSuccess,
    isError,
  }] = useLazyGetPaymentsToExpertsReportQuery();

  const [hasSearched, setHasSearched] = useState(false);

  const buildRequest = (overridePage = page) => ({
    params: {
      page: overridePage,
      date_from: moment(date_from).format('YYYY-MM-DD'),
      date_to:   moment(date_to).format('YYYY-MM-DD'),
    },
  });

  const onSearch = () => {
    setQuery({ page: 1 });
    setHasSearched(true);
    trigger(buildRequest(1));
  };

  const onChangePage = (newPage: number) => {
    setQuery({ page: newPage });
    trigger(buildRequest(newPage));
  };

  return (
      <>
        <AppBar title="Выплаты экспертам" />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" spacing={2} alignItems="center">
              <DatePicker
                  mask="__.__.____"
                  label="Дата от"
                  value={date_from}
                  maxDate={moment(date_to)}
                  onChange={v => setQuery({ date_from: v ? moment(v).toDate() : undefined })}
                  disabled={isFetching}
                  renderInput={params => (
                      <TextField {...params} name="date_from" variant="filled" size="small" />
                  )}
              />

              <DatePicker
                  mask="__.__.____"
                  label="Дата до"
                  value={date_to}
                  maxDate={moment()}
                  onChange={v => setQuery({ date_to: v ? moment(v).toDate() : undefined })}
                  disabled={isFetching}
                  renderInput={params => (
                      <TextField {...params} name="date_to" variant="filled" size="small" />
                  )}
              />

              <LoadingButton
                  onClick={onSearch}
                  loading={isFetching}
                  disabled={isFetching}
                  variant="contained"
                  size="large"
              >
                Поиск
              </LoadingButton>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            {!hasSearched ? (
                <Empty text="Нажмите «Поиск», чтобы увидеть данные" />
            ) : isLoading ? (
                <Loader />
            ) : isError ? (
                <Error text="Произошла ошибка с загрузкой данных! Пожалуйста, попробуйте позже" />
            ) : isSuccess && paymentsToExperts?.data?.length ? (
                <PaymentsToExpertsTable
                    list={paymentsToExperts}
                    page={page}
                    onChangePage={onChangePage}
                />
            ) : (
                <Empty text="Данные отсутствуют" />
            )}
          </Grid>
        </Grid>
      </>
  );
};

export default PaymentsToExpertsReportPage;
